// import { useState } from 'react'
// import { Dialog, DialogPanel } from '@headlessui/react'
// import { Bars3Icon, XMarkIcon } from '@heroicons/react/24/outline'
// import Logo from '../../assets/logo_1.png'
// import { Link, useNavigate } from 'react-router-dom'
// // import { logout } from '../../../utils/auth'
// import { toast } from 'react-toastify'
// import 'react-toastify/dist/ReactToastify.css'

// const navigation = [
//   { name: 'Home', href: '/home' },
//   { name: 'About', href: '/abouts' },
//   // { name: 'Services', href: '/services' },
//   { name: 'Contact', href: '/contacts' },
//   { name: 'Dashboard', href: '/teacher/dashboard' },
//   // { name: 'Profile', href: '/teacher/profile' },
// ]

// export default function Header() {
//   const navigate = useNavigate()
//   // const toRegister = () => {
//   //   navigate('/register')
//   // }
//   const toLogout = () => {
//     navigate('/logout/')
//     toast.success('You have logged out', {
//       position: 'top-right',
//       autoClose: 3000,
//       theme: 'colored',
//     })
//   }

//   const [mobileMenuOpen, setMobileMenuOpen] = useState(false)

//   return (
//     <div className="bg-white">
//       <header className="absolute inset-x-0 top-0 z-50">
//         <nav
//           aria-label="Global"
//           className="flex items-center justify-between p-6 lg:px-8"
//         >
//           <div className="flex lg:flex-1">
//             <a href="/" className="-m-1.5 p-1.5">
//               <span className="sr-only">Your Company</span>
//               <Link to="/">
//                 <img alt="" src={Logo} className="mt-[-20px] h-[80px] w-[200px]" />
//               </Link>
//             </a>
//           </div>
//           <div className="flex lg:hidden">
//             <button
//               type="button"
//               onClick={() => setMobileMenuOpen(true)}
//               className="-m-2.5 inline-flex items-center justify-center rounded-md p-2.5 text-gray-700"
//             >
//               <span className="sr-only">Open main menu</span>
//               <Bars3Icon aria-hidden="true" className="h-6 w-6" />
//             </button>
//           </div>
//           <div className="hidden lg:flex lg:gap-x-12">
//             {navigation.map((item) => (
//               <a
//                 key={item.name}
//                 href={item.href}
//                 className="text-sm font-semibold leading-6 text-gray-900"
//               >
//                 {item.name}
//               </a>
//             ))}
//           </div>
//           <button
//             className="hidden lg:flex lg:flex-1 lg:justify-end"
//             type="submit"
//             onClick={toLogout}
//           >
//             Log out <span aria-hidden="true">&rarr;</span>
//           </button>
//         </nav>
//         <Dialog
//           open={mobileMenuOpen}
//           onClose={setMobileMenuOpen}
//           className="lg:hidden"
//         >
//           <div className="fixed inset-0 z-50" />
//           <DialogPanel className="fixed inset-y-0 right-0 z-50 w-full overflow-y-auto bg-white px-6 py-6 sm:max-w-sm sm:ring-1 sm:ring-gray-900/10">
//             <div className="flex items-center justify-between">
//               <a href="#" className="-m-1.5 p-1.5">
//                 <span id="bt" className="sr-only">
//                   Your Company
//                 </span>
//                 <img alt="" src="" className="h-8 w-auto" />
//               </a>
//               <button
//                 type="button"
//                 onClick={() => setMobileMenuOpen(false)}
//                 className="-m-2.5 rounded-md p-2.5 text-gray-700"
//               >
//                 <span className="sr-only">Close menu</span>
//                 <XMarkIcon aria-hidden="true" className="h-6 w-6" />
//               </button>
//             </div>
//             <div className="mt-6 flow-root">
//               <div className="-my-6 divide-y divide-gray-500/10">
//                 <div className="space-y-2 py-6">
//                   {navigation.map((item) => (
//                     <a
//                       key={item.name}
//                       href={item.href}
//                       className="-mx-3 block rounded-lg px-3 py-2 text-base font-semibold leading-7 text-gray-900 hover:bg-gray-50"
//                     >
//                       {item.name}
//                     </a>
//                   ))}
//                 </div>
//                 <button className="py-6" type="submit" onClick={toLogout}>
//                   Lout out
//                 </button>
//               </div>
//             </div>
//           </DialogPanel>
//         </Dialog>
//       </header>
//     </div>
//   )
// }



// import { useState } from 'react'
// import { useNavigate } from 'react-router-dom'
// import { Dialog, DialogPanel } from '@headlessui/react'
// import { Bars3Icon, XMarkIcon } from '@heroicons/react/24/outline'
// import Logo from '../../../assets/logo_1.png'
// import { Link } from 'react-router-dom'
// import { toast } from 'react-toastify'

// const navigation = [
//   { name: 'Home', href: '/' },
//   { name: 'About', href: '/about' },
//   // { name: 'Services', href: '/services' },
//   { name: 'Contact', href: '/contact' },
//   { name: 'Dashboard', href: '/dashboard' },
//   // { name: 'Register', href: '/register' },
// ]
// // const logreg = [
// //   { name: 'Login', href: '/login' },
// //   { name: 'Register', href: '/register' },
// // ]

// export default function Header() {
//   const navigate = useNavigate()
//   const toLogout = () => {
//     navigate('/logout/')
//     toast.success('You have logged out', {
//       position: 'top-right',
//       autoClose: 3000,
//       theme: 'colored',
//     })
//   }
//   const [mobileMenuOpen, setMobileMenuOpen] = useState(false)
//   return (
//     <div className="bg-white">
//       <header className="absolute inset-x-0 top-0 z-50">
//         <nav
//           aria-label="Global"
//           className="flex items-center justify-between py-12 px-6 lg:px-8"
//         >
//           <div className="flex lg:flex-1">
//             <a href="#" className="-m-1.5 p-1.5">
//               <span className="sr-only">Your Company</span>
//               <Link to="/">
//                 <img alt="" src={Logo} className="mt-[-20px] h-[80px] w-[200px]" />
//               </Link>
//             </a>
//           </div>
//           <div className="flex lg:hidden">
//             <button
//               type="button"
//               onClick={() => setMobileMenuOpen(true)}
//               className="-m-2.5 inline-flex items-center justify-center rounded-md p-2.5 text-gray-700"
//             >
//               <span className="sr-only">Open main menu</span>
//               <Bars3Icon aria-hidden="true" className="h-6 w-6" />
//             </button>
//           </div>
//           <div className="hidden lg:flex lg:gap-x-12">
//             {navigation.map((item) => (
//               <a
//                 key={item.name}
//                 href={item.href}
//                 className="text-sm font-semibold leading-6 text-gray-900"
//               >
//                 {item.name}
//               </a>
//             ))}
//           </div>
//           <button
//             className="hidden lg:flex lg:flex-1 lg:justify-end"
//             type="submit"
//             onClick={toLogout}
//           >
//             Log out <span aria-hidden="true">&rarr;</span>
//           </button>

//         </nav>
//         <Dialog
//           open={mobileMenuOpen}
//           onClose={setMobileMenuOpen}
//           className="lg:hidden"
//         >
//           <div className="fixed inset-0 z-50" />
//           <DialogPanel className="fixed inset-y-0 right-0 z-50 w-full overflow-y-auto bg-white px-6 py-6 sm:max-w-sm sm:ring-1 sm:ring-gray-900/10">
//             <div id="bt" className="flex items-center justify-between">
//               <a href="#" className="-m-1.5 p-1.5">
//                 <span className="sr-only">Your Company</span>
//                 <img alt="" src="" className="h-8 w-auto" />
//               </a>
//               <button
//                 type="button"
//                 onClick={() => setMobileMenuOpen(false)}
//                 className="-m-2.5 rounded-md p-2.5 text-gray-700"
//               >
//                 <span className="sr-only">Close menu</span>
//                 <XMarkIcon aria-hidden="true" className="h-6 w-6" />
//               </button>
//             </div>
//             <div className="mt-6 flow-root">
//               <div className="-my-6 divide-y divide-gray-500/10">
//                 <div className="space-y-2 py-6">
//                   {navigation.map((item) => (
//                     <a
//                       key={item.name}
//                       href={item.href}
//                       className="-mx-3 block rounded-lg px-3 py-2 text-base font-semibold leading-7 text-gray-900 hover:bg-gray-50"
//                     >
//                       {item.name}
//                     </a>
//                   ))}
//                 </div>
//               </div>
//               <button
//                 className="hidden lg:flex lg:flex-1 lg:justify-end"
//                 type="submit"
//                 onClick={toLogout}
//               >
//                 Log out <span aria-hidden="true">&rarr;</span>
//               </button>

//             </div>
//           </DialogPanel>
//         </Dialog>
//       </header>
//     </div>
//   )
// }


//           // {/* Navigation menu */}
//           // {navigationItems.map((item, index) => (
//           //   <div
//           //     key={index}
//           //     className={`absolute w-[231px] h-10 ${
//           //       index === 0
//           //         ? "top-[131px] left-[21px]"
//           //         : index === 1
//           //           ? "top-[200px] left-5"
//           //           : index === 2
//           //             ? "top-[264px] left-[21px]"
//           //             : index === 3
//           //               ? "top-[343px] left-6"
//           //               : "top-[412px] left-[21px]"
//           //     }`}
//           //   >
//           //     <div
//           //       className={`absolute w-[143px] h-[13px] top-[11px] left-14 [font-family:'Lato',Helvetica] font-normal ${
//           //         item.isActive ? "text-[#3384ff]" : "text-[#3c3939]"
//           //       } text-base tracking-[0] leading-[13px]`}
//           //     >
//           //       {item.label}
//           //     </div>
//           //     <img
//           //       className="absolute w-9 h-9 top-0 left-0"
//           //       alt={item.label}
//           //       src={item.icon}
//           //     />
//           //   </div>
//           // ))}

//           // // {/* Bottom navigation items */}
//           // // <div className="absolute w-9 h-9 top-[884px] left-[18px]">
//           // //   <div className="relative w-[30px] h-[30px] top-[3px] left-[3px] bg-[url(https://c.animaapp.com/etPela4A/img/vector-2@2x.png)] bg-[100%_100%]" />
//           // // </div>

//           // // <div className="absolute w-[140px] h-[13px] top-[896px] left-[67px] [font-family:'Lato',Helvetica] font-normal text-[#3c3939] text-base tracking-[0] leading-[13px]">
//           // //   Help
//           // // </div>

//           // // <img
//           // //   className="absolute w-[201px] h-[3px] top-[858px] left-[31px] object-cover"
//           // //   alt="Divider line"
//           // //   src="https://c.animaapp.com/etPela4A/img/line-1@2x.png"
//           // // />

//           // // <div className="absolute w-6 h-6 top-[953px] left-6">
//           // //   <div className="relative w-5 h-[18px] top-[3px] left-0.5 bg-[url(https://c.animaapp.com/etPela4A/img/vector-3@2x.png)] bg-[100%_100%]" />
//           // // </div>

//           // // <div className="absolute w-[140px] h-[13px] top-[956px] left-[67px] [font-family:'Lato',Helvetica] font-normal text-[#3c3939] text-base tracking-[0] leading-[13px]">
//           // //   Logout
//           // // </div>



import { useState, useEffect } from 'react'
import ApiClient from '../../api/client'
import { Menu, X } from 'lucide-react'
import SearchBar from './SearchBar'
import { useUIStore } from '../../../store/useUIStore'


const Navbar = () => {
  const { isCollapsed, setIsCollapsed, activeMenu, isMobile } = useUIStore()
  const [profilePic, setProfilePic] = useState("")
  // const [searchQuery, setSearchQuery] = useState('')
  const apiClient = new ApiClient()

  const toggleSidebar = () => setIsCollapsed(!isCollapsed);

  useEffect(()=> {

    const fetchProfilePic = async() => {
      try {
        const { data, error } = await apiClient.userProfilePic()
        if(data){
          setProfilePic(data)
        }else{
          setError(error)
        }
      }catch(error){
        setError(error || 'Error fetching image')
      }
    }
    fetchProfilePic()
  }, [])


  return (
    <div>
      <header className="bg-white border-b border-gray-200 px-6 py-4">
        <div className="flex items-center justify-between">
          <div className="flex items-center">
            {/* Mobile Menu Button */}
            {/* {isMobile && ( */}
              <button
                onClick={toggleSidebar}
                className="mr-4 p-2 rounded-lg hover:bg-gray-100"
              >
                {isCollapsed ? <Menu className="w-5 h-5 text-gray-600" />: <X />}
              </button>
            {/* )} */}
            <div className='flex items-center'>
              <h2 className="ml-8 text-xl font-semibold text-gray-800 mr-8">{activeMenu}</h2>
              {!isMobile && <SearchBar />}
            </div>
          </div>
          
          <div className="flex items-center space-x-4 mr-8">
            <div className="w-8 h-8 rounded-full flex items-center justify-center">
              {profilePic && profilePic?.image ? (
                <img className="rounded-full" src={profilePic?.image} alt="" />
              ):profilePic && profilePic?.full_name ? (
                <span className="text-blue-800 text-md font-bold">{profilePic?.full_name}</span>
              ):(
                <span className="text-blue-600">User</span>
              )}
              
            </div>
          </div>
        </div>
      </header>

    </div>
  )
}

export default Navbar